import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

import Home from "@/pages/Home";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import Onboarding from "@/pages/Onboarding";
import Payment from "@/pages/Payment";
import Dashboard from "@/pages/Dashboard";
import Matching from "@/pages/Matching";
import Matches from "@/pages/Matches";
import MatchDetail from "@/pages/MatchDetail";
import Profile from "@/pages/Profile";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import Legal from "@/pages/Legal";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-dc-gradient flex items-center justify-center text-purple-200">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App bg-dc-gradient min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors closeButton />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
            <Route path="/pay" element={<Protected><Payment /></Protected>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/match" element={<Protected><Matching /></Protected>} />
            <Route path="/matches" element={<Protected><Matches /></Protected>} />
            <Route path="/matches/:id" element={<Protected><MatchDetail /></Protected>} />
            <Route path="/profile" element={<Protected><Profile /></Protected>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/terms" element={<Legal page="terms" />} />
            <Route path="/privacy" element={<Legal page="privacy" />} />
            <Route path="/refund" element={<Legal page="refund" />} />
            <Route path="/18-plus" element={<Legal page="eighteen" />} />
            <Route path="/safety" element={<Legal page="safety" />} />
            <Route path="/contact" element={<Legal page="contact" />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
